import { execOnLoad } from '@general/helpers';
import { openModal } from '@components/modals';
import './newsletter.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initNewsletter = async (context) => {
  const sectionContainer = context.classList.contains('.shopify-section')
    ? context
    : context.closest('.shopify-section');
  if (!sectionContainer) return;

  const newsletterDrawer = document.querySelector('#NewsletterDrawer');
  const newsletterTriggers = document.querySelectorAll(
    'a[href="#modal-newsletter"], .footer-c__newsletter',
  );
  newsletterTriggers.forEach((newsletterTrigger) => {
    if (newsletterDrawer && newsletterTrigger) {
      newsletterTrigger.addEventListener('click', (e) => {
        e.preventDefault();
        openModal(newsletterDrawer);
      });
    }
  });

  const closeNewsletterDrawer = document.querySelector(
    '#NewsletterDrawer .modal__close',
  );
  const closeNewsletterPopup = document.querySelector(
    '#newsletter .modal__close',
  );

  if (closeNewsletterDrawer && closeNewsletterPopup) {
    closeNewsletterDrawer.addEventListener('click', () => {
      closeNewsletterPopup.click();
    });
  }
};

execOnLoad(window.dAgency.initNewsletter, '.newsletter__section');
